// extracted by mini-css-extract-plugin
export default {"media":"index_media_NCYaQ","picInfo":"index_picInfo_Fw2Hz","picList":"index_picList_IeuC1"};